import { CopyIcon, InfoIcon } from '@chakra-ui/icons';
import { Button, HStack, IconButton, Popover, PopoverArrow, PopoverBody, PopoverCloseButton, PopoverContent, PopoverHeader, PopoverTrigger, useColorModeValue, useToast } from '@chakra-ui/react';

const PopoverId = ({ index, content, header = 'DBI', place = 'N/A', id = true, fs = "md" }) => {
    const toast = useToast();

    const handleCopy = () => {
        if (id) {
            navigator.clipboard.writeText(content + " - " + place);
        } else {
            navigator.clipboard.writeText(content);
        }
        toast({
            title: `Copied`,
            description: `${header} copied!`,
            status: "success",
            duration: 1500,
            position: "top-right",
            isClosable: true,
        });
    };

    return (
        <Popover placement="right">
            <PopoverTrigger>
                <Button fontSize={fs} variant="none" fontWeight="normal">
                    {id ? index + 1 : <InfoIcon />}
                </Button>
            </PopoverTrigger>
            <PopoverContent bg={useColorModeValue("white", "gray.800")} color={useColorModeValue("black", "white")}>
                <PopoverArrow bg={useColorModeValue("white", "gray.800")} />
                <PopoverCloseButton />
                <PopoverHeader fontWeight="bold">{`${header} - ${place}`}</PopoverHeader>
                <PopoverBody>
                    <HStack justify="space-between">
                        <span>{content}</span>
                        <IconButton
                            icon={<CopyIcon />}
                            aria-label="Copy to clipboard"
                            size="sm"
                            onClick={handleCopy}
                            variant="ghost"
                        />
                    </HStack>
                </PopoverBody>
            </PopoverContent>
        </Popover>

    );
};

export default PopoverId;
